import { useId, useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import './GoodToKnowSection.css';

gsap.registerPlugin(useGSAP, ScrollTrigger);

const faqs = [
  {
    question: 'Where are the JamRock Escape stays?',
    answer: 'Explore our Valdosta, Georgia and St Mary, Jamaica homes.',
  },
  {
    question: 'Can I book the Hillsboro property?',
    answer: 'Not yet. The Oregon home is not currently available for booking.',
  },
  {
    question: 'Where will I find rates and house rules?',
    answer: 'Review the details for your selected property before booking.',
  },
];

export default function GoodToKnowSection({ ready = true, contactHref = '/contact' }) {
  const scope = useRef(null);
  const titleId = useId();

  useGSAP(() => {
    if (!ready) return;
    const media = gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      const select = gsap.utils.selector(scope);
      gsap.timeline({
        defaults: { duration: 0.8, ease: 'power3.out', clearProps: 'transform,opacity,visibility' },
        scrollTrigger: { trigger: scope.current, start: 'top 80%', once: true },
      })
        .from(select('.good-to-know__eyebrow'), { autoAlpha: 0, y: 10 }, 0)
        .from(select('.good-to-know__heading'), { autoAlpha: 0, y: 25 }, 0.12)
        .from(select('.good-to-know__contact'), { autoAlpha: 0, y: 20 }, 0.24)
        .from(select('.good-to-know__item'), { autoAlpha: 0, y: 28, stagger: 0.14 }, 0.2);
    });
    return () => media.revert();
  }, { scope, dependencies: [ready], revertOnUpdate: true });

  return (
    <section ref={scope} className="good-to-know" aria-labelledby={titleId}>
      <div className="good-to-know__inner">
        <div className="good-to-know__intro">
          <p className="good-to-know__eyebrow">GOOD TO KNOW</p>
          <h2 className="good-to-know__heading" id={titleId}>A few questions<br />before you go.</h2>
          <div className="good-to-know__contact">
            <p className="good-to-know__support">Have something else in mind?</p>
            <a className="good-to-know__link" href={contactHref}>Get in touch</a>
          </div>
        </div>
        <div className="good-to-know__list">
          {faqs.map(({ question, answer }) => (
            <article className="good-to-know__item" key={question}>
              <h3 className="good-to-know__question">{question}</h3>
              <p className="good-to-know__answer">{answer}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
